<template>
  <select 
    :placeholder="$t('building_page.district')"
    v-model="value">
    <option v-for="(district, index) in districtGroups" :value="district.id">
      {{ $i18n.locale === 'en' ? district.nameEn : district.nameZh }}
    </option>
  </select>
</template>

<script>
const districtGroups = [
  {
    id: '',
    nameZh: '物業地區',
    nameEn: 'All Districts',
  },
  {
    id: 1,
    nameZh: '中西區',
    nameEn: 'Central and Western District',
  },
  {
    id: 2,
    nameZh: '灣仔區',
    nameEn: 'Wan Chai District',
  },
  {
    id: 3,
    nameZh: '東區',
    nameEn: 'Eastern District',
  },
  
  {
    id: 5,
    nameZh: '油尖旺區',
    nameEn: 'Yau Tsim Mong District',
  },

  {
    id: 9,
    nameZh: '觀塘區',
    nameEn: 'Kwun Tong District',
  },
  {
    id: 10,
    nameZh: '葵青區',
    nameEn: 'Kwai Tsing District',
  },
  {
    id: 11,
    nameZh: '荃灣區',
    nameEn: 'Tsuen Wan District',
  },
  {
    id: 12,
    nameZh: '屯門區',
    nameEn: 'Tuen Mum District',
  },
  {
    id: 13,
    nameZh: '元朗區',
    nameEn: 'Yuen Long District',
  },
  {
    id: 14,
    nameZh: '北區',
    nameEn: 'Northern District',
  },
  {
    id: 15,
    nameZh: '大埔區',
    nameEn: 'Tai Po District',
  },
  {
    id: 16,
    nameZh: '沙田區',
    nameEn: 'Sha Tin District',
  },
  {
    id: 4,
    nameZh: '南區',
    nameEn: 'Southern District',
  },
  {
    id: 6,
    nameZh: '深水埗區',
    nameEn: 'Sham Shui Po District',
  },
  {
    id: 7,
    nameZh: '九龍城區',
    nameEn: 'Kowloon City District',
  },
  {
    id: 8,
    nameZh: '黃大仙區',
    nameEn: 'Wong Tai Sin District',
  },
];

export default {
  props: ['districtId'],
  data() {
    return {
      value: '',
      districtGroups,
    };
  },
  watch: {
    value(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
select {
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 5px;  
}
</style>
